import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

const twDefaults = {
  backgroundColor: 'bg-accent',
  width: 'w-64',
  padding: 'py-4',
  fontSize: 'text-md',
  color: 'text-white',
  textTransform: 'uppercase',
  margin: 'mt-6 mx-auto',
  letterSpacing: 'tracking-wide',
};

/**
 *
 * @param classes
 * @param defaults
 * @return {string}
 */
const applyTwClasses = (classes, defaults) => {
  return Object.values({
    ...defaults,
    ...classes,
  }).join(' ');
};

export const Button = ({
  text = 'Add some text',
  type = 'button',
  twClasses = twDefaults,
  onClick,
}) => {
  const classes = applyTwClasses(twClasses, twDefaults);
  return (
    <button className={classes} type={type} onClick={onClick}>
      {text}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  twClasses: PropTypes.shape({
    backgroundColor: PropTypes.string,
    width: PropTypes.string,
    padding: PropTypes.string,
    fontSize: PropTypes.string,
    color: PropTypes.string,
    textTransform: PropTypes.string,
    margin: PropTypes.string,
  }),
};

const ButtonDefault = styled('button')`
  ${tw`bg-accent py-4 px-8 text-md text-white uppercase tracking-wide border-1 border-accent`}
`;

export default ButtonDefault;

export const ButtonPrimary = styled(ButtonDefault)`${tw`bg-primary border-primary`}`;


// WEBPACK FOOTER //
// ./src/components/Button.js